import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import axios from "axios";
import MultiSelectCheckbox from "../../components/MultiSelectCheckbox.js";
import Select from "react-select";
import { apiFetch } from "../../api.js";

const ExpAllowMasterDetailsDesign = () => {
  const navigate = useNavigate();
  const [Type, setType] = useState("Allowanced");
  const [Description, setDescription] = useState("");
  const [Allowanced, setAllowanced] = useState("");
  const [AllowancedList, setAllowancedList] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const routerLocation = useLocation();
  const [ipAddress, setIpAddress] = useState("");
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const location = useLocation();
  const [editId, setEditId] = useState("");
  const editUnqid = location.state?.unqid || "";

  useEffect(() => {
    axios
      .get("/api/get-ip")
      .then((res) => setIpAddress(res.data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  //------Exp-Allow_CategoryFetch
  useEffect(() => {
    fetchCategory();
  }, []);
  const fetchCategory = async () => {
    try {
      const res = await apiFetch(
        "/api/exp-allowance/category",
      );
      const data = await res.json();
      const list = data.map((x) => ({
        value: x.data,
        label: x.value,
      }));
      setAllowancedList(list);
    } catch (err) {
      console.error("Category Fetch Failed", err);
    }
  };
  //------Exp-Allow_SaveWorking
  const handleSave = async () => {
    if (!Description.trim()) {
      alert("Description is required");
      return;
    }

    if (!Allowanced) {
      alert("Please select category");
      return;
    }

    const payload = {
      description: Description,
      categoryId: Allowanced,
      type: Type === "Allowanced" ? 0 : 1,
      ip: ipAddress,
      userId: storedUserInfo.userid,
    };

    try {
      const res = await apiFetch(
        "/api/exp-allowance/save",
        {
          method: "POST",
          body: JSON.stringify(payload), // ✅ FIX
        },
      );

      if (!res.ok) {
        const errText = await res.text();
        console.error("SAVE ERROR:", errText);
        alert("Save failed");
        return;
      }

      const data = await res.json(); // ✅ FIX

      if (data?.err === "0") {
        alert("Saved successfully ✅");
        setDescription("");
        setAllowanced("");
        setType("Allowanced");
        navigate("/ExpAllowMasterGrid"); // ✅ moved inside success
      } else {
        alert(data?.msg || "Save failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };
  //------Exp-Allow_ExitWorking
  const handleExit = () => {
    navigate("/ExpAllowMasterGrid");
  };
  //------Exp-Allow_EditWorking
  useEffect(() => {
    if (editUnqid) {
      setIsEditing(true);
      fetchEditData(editUnqid);
    }
  }, [editUnqid]);

  const fetchEditData = async (id) => {
    try {
      const res = await apiFetch(
        `/api/exp-allowance/edit?unqid=${encodeURIComponent(id)}`, // ✅ FIX
        { method: "GET" },
      );

      if (!res.ok) {
        const errText = await res.text();
        console.error("EDIT FETCH ERROR:", errText);
        return;
      }

      const data = await res.json(); // ✅ FIX

      if (data && data.length > 0) {
        const row = data[0];

        setDescription(row.descr);
        setAllowanced(row.unqid);
        setType(row.allowexpensesval === 0 ? "Allowanced" : "Expenses");
        setEditId(id);
      }
    } catch (err) {
      console.error("Edit fetch error", err);
    }
  };
  //------Exp-Allow_UpdateWorking
  const handleUpdate = async () => {
    if (!Description.trim()) {
      alert("Description is required");
      return;
    }

    if (!Allowanced) {
      alert("Please select category");
      return;
    }

    try {
      const res = await apiFetch(
        "/api/exp-allowance/update",
        {
          method: "POST",
          body: JSON.stringify({
            unqid: editId,
            description: Description,
            categoryId: Allowanced,
            type: Type === "Allowanced" ? 0 : 1,
          }),
        },
      );

      if (!res.ok) {
        const errText = await res.text();
        console.error("UPDATE ERROR:", errText);
        alert("Update failed");
        return;
      }

      const data = await res.json(); // ✅ FIX

      if (data?.err === "0") {
        alert("Updated successfully ✅");
        navigate("/ExpAllowMasterGrid");
      } else {
        alert(data?.msg || "Update failed");
      }
    } catch (err) {
      console.error("Update error", err);
      alert("Server error");
    }
  };
  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Expenses/Allowanced Master</div>

          {/* ---------------- FORM ROW (NOW COMPACT & CLEAN) ---------------- */}
          <div className="form-row compact-row">
            {/* TYPE SECTION */}
            <div className="type-box">
              <label className="section-label">Type</label>

              <div className="radio-group small-radio">
                <label className="radio-item">
                  <input
                    type="radio"
                    value="Allowanced"
                    checked={Type === "Allowanced"}
                    onChange={(e) => setType(e.target.value)}
                  />
                  Allowanced
                </label>

                <label className="radio-item">
                  <input
                    type="radio"
                    value="Expenses"
                    checked={Type === "Expenses"}
                    onChange={(e) => setType(e.target.value)}
                  />
                  Expenses
                </label>
              </div>
            </div>

            {/* DESCRIPTION */}
            <div className="form-column">
              <label>Description</label>
              <input
                type="text"
                value={Description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            {/* MAIN CATEGORY */}
            <div className="form-column">
              <label>Category</label>
              <Select
                options={AllowancedList}
                value={
                  AllowancedList.find((o) => o.value === Allowanced) || null
                }
                onChange={(selected) =>
                  setAllowanced(selected ? selected.value : "")
                }
                placeholder="Select Category"
                isSearchable
                styles={{
                  control: (base, state) => ({
                    ...base,
                    height: "40px",
                    minHeight: "40px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    boxShadow: "none",
                    fontSize: "14px",
                    backgroundColor: "#fff",
                    "&:hover": {
                      borderColor: "#999",
                    },
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    padding: "0 10px",
                  }),
                  indicatorsContainer: (base) => ({
                    ...base,
                    height: "40px",
                  }),
                }}
              />
            </div>
          </div>

          {/* ---------------- BUTTONS ---------------- */}
          <div className="button-container">
            {!isEditing && (
              <button className="btn-save" type="button" onClick={handleSave}>
                Save
              </button>
            )}

            {isEditing && (
              <button className="btn-update" onClick={handleUpdate}>
                Update
              </button>
            )}

            <button className="btn-exit" onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* ----------------------------------------------------
            CSS - YOUR ORIGINAL STYLE + IMPROVEMENTS
      ---------------------------------------------------- */}
      <style>
        {`
/* ===== PAGE LAYOUT ===== */
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1200px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

/* HEADER */
.header {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 15px;
  background: #8B1E3F;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ================= RESPONSIVE GRID ================= */

/* Desktop default */
.compact-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  align-items: center;
}

/* Tablet */
@media (max-width: 1024px) {
  .compact-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 600px) {
  .compact-row {
    grid-template-columns: 1fr;
  }
}

/* ---------- TYPE BLOCK ---------- */
.type-box {
  display: flex;
  flex-direction: column;
}

.section-label {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 6px;
}

/* Radio styling */
.radio-group {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 14px;
}

.small-radio input[type="radio"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
}

/* INPUTS */
.form-column {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

input,
select {
  height: 40px !important;
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #fff;
  box-sizing: border-box;
  font-size: 14px;
}

/* ================= BUTTONS ================= */

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.btn-save,
.btn-update,
.btn-exit {
  min-width: 120px;
  height: 42px;
  padding: 0 22px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  color: white;
  white-space: nowrap;
}

.btn-save {
  background: #4caf50;
}

.btn-update {
  background: #2e20abff;
}

.btn-exit {
  background: #a20d0d;
}
`}
      </style>
    </Layout>
  );
};

export default ExpAllowMasterDetailsDesign;
